import React from 'react';

interface IconProps {
  size?: number;
  className?: string;
  ariaHidden?: boolean;
  ariaLabel?: string;
}

const IconCategoryAndCollection: React.FC<IconProps> = ({
  size = 16,
  className,
  ariaHidden = true,
  ariaLabel,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 15 15"
    fill="none"
    className={className}
    aria-hidden={ariaHidden ? true : undefined}
    aria-label={ariaLabel}
  >
    <path
      d="M11.1924 7.70215C13.0987 7.70225 14.6445 9.24795 14.6445 11.1543C14.6445 11.9733 14.3585 12.7255 13.8818 13.3174L14.8848 14.3555C15.0286 14.5044 15.0248 14.7418 14.876 14.8857C14.7271 15.0294 14.4896 15.0247 14.3457 14.876L13.3506 13.8467C12.7593 14.3213 12.0094 14.6064 11.1924 14.6064C9.28602 14.6064 7.7404 13.0606 7.74023 11.1543C7.7403 9.24789 9.28596 7.70215 11.1924 7.70215ZM5.78906 7.70215C6.4101 7.70246 6.91403 8.20605 6.91406 8.82715V13.4814C6.91383 14.1024 6.40997 14.6061 5.78906 14.6064H1.13477C0.513588 14.6064 0.00999646 14.1026 0.00976563 13.4814L0.00976563 8.82715C0.00979862 8.20586 0.513466 7.70215 1.13477 7.70215H5.78906ZM1.13477 8.45215C0.927679 8.45215 0.759799 8.62007 0.759766 8.82715L0.759766 13.4814C0.759996 13.6884 0.927801 13.8564 1.13477 13.8564H5.78906C5.99576 13.8561 6.16383 13.6882 6.16406 13.4814V8.82715C6.16403 8.62026 5.99588 8.45246 5.78906 8.45215H1.13477ZM11.1924 8.45215C9.70017 8.45215 8.4903 9.6621 8.49023 11.1543C8.4904 12.6464 9.70024 13.8564 11.1924 13.8564C12.6844 13.8563 13.8944 12.6463 13.8945 11.1543C13.8945 9.66217 12.6845 8.45225 11.1924 8.45215ZM5.78906 0.00976562C6.41006 0.0100792 6.91396 0.513723 6.91406 1.13477V5.78906C6.91383 6.40999 6.40997 6.91375 5.78906 6.91406H1.13477C0.513588 6.91406 0.00999646 6.41019 0.00976563 5.78906L0.00976563 1.13477C0.00986459 0.513529 0.513506 0.00976562 1.13477 0.00976562L5.78906 0.00976562ZM13.4814 0.00976562C14.1025 0.00994745 14.6063 0.513642 14.6064 1.13477V5.78906C14.6062 6.41007 14.1025 6.91388 13.4814 6.91406H8.82715C8.20597 6.91406 7.70238 6.41019 7.70215 5.78906V1.13477C7.70225 0.513529 8.20589 0.00976562 8.82715 0.00976562L13.4814 0.00976562ZM1.13477 0.759766C0.92772 0.759766 0.759865 0.927743 0.759766 1.13477L0.759766 5.78906C0.759996 5.99597 0.927801 6.16406 1.13477 6.16406H5.78906C5.99576 6.16375 6.16383 5.99578 6.16406 5.78906V1.13477C6.16396 0.927936 5.99584 0.760079 5.78906 0.759766L1.13477 0.759766ZM8.82715 0.759766C8.6201 0.759766 8.45225 0.927743 8.45215 1.13477V5.78906C8.45238 5.99597 8.62018 6.16406 8.82715 6.16406H13.4814C13.6883 6.16388 13.8562 5.99586 13.8564 5.78906V1.13477C13.8563 0.927855 13.6883 0.759947 13.4814 0.759766L8.82715 0.759766Z"
      fill="currentColor"
    />
  </svg>
);

export default IconCategoryAndCollection;
